import { TAvailableConfigValues } from '@customTypes/common';

export interface IFragmentsBufferConfig {
  numberOfFragmentsToKeepInBuffer: number;
  baseChunksSaverUrl: string;
  saveProbability: number;
}

export const defaultFragmentsBufferConfig: IFragmentsBufferConfig = {
  numberOfFragmentsToKeepInBuffer: 3,
  baseChunksSaverUrl: 'chunks.doppiostreams.com',
  saveProbability: 0.05,
};

export const availableFragmentsBufferConfigValues: TAvailableConfigValues<IFragmentsBufferConfig> = {};
